const PayeeTypeEnum = Object.freeze({
  BPAY_BILLER: "BPAY_BILLER",
  DOMESTIC_PAYEE: "DOMESTIC_PAYEE",
});

export default PayeeTypeEnum;
